<template>
  <b-card no-body>

    <div v-if="pending > 0" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>

    <b-card-header class="pb-50">
      <h5> {{ $t( config.label + ' ' + 'Filters')}} </h5>
    </b-card-header>

    <b-card-body>

      <b-row>
         
         <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2" v-if="!hidden.includes('categories')">
           <label>{{ $t('Categories') }}</label>
           <v-select 
              multiple 
              :close-on-select="false"
              :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
              label="name"
              :options="categoryOptions.map(i=>({id:i,name:$t(i)}))"
              v-model="categoryValue"
              class="w-100"
           />
         </b-col>
 
         <b-col lg="6" md="12" class="mb-md-0 mb-2" v-if="!hidden.includes('owners')">
           <label>{{$t('Owners')}}</label>
           <v-select 
              multiple 
              :close-on-select="false"
              :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"    
              label="name"
              :options="ownerOptions"
              v-model="ownerValue"
              class="w-100"
           />
         </b-col>
 
         <b-col lg="6" md="12" class="mb-md-0 mb-2" v-if="!hidden.includes('types')">
           <label>{{$t('types')}}</label>
           <v-select
                multiple 
               :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"              
               :options="typeOptions.filter((type)=> categoryValue.length == 0 || categoryValue.filter((option) => option.id == type.category).length > 0)"
               :getOptionLabel="option => option.name"
               v-model="typeValue"
               class="w-100"
           />
         </b-col>
 
         <b-col lg="6" md="12" class="mb-md-0 mb-2" v-if="!hidden.includes('contracts')">
           <label>{{$t('Contracts')}}</label>
           <v-select  
              multiple
              :close-on-select="false"
              :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
              :getOptionLabel="option => option.name"
              :options="contractOptions.filter((contract)=> ownerValue.length == 0 || ownerValue.filter((option) => option.id == contract.contractor_id).length > 0)"
              v-model="contractValue"
              class="w-100"
           />
         </b-col>
 
 
       </b-row>

    </b-card-body>
  </b-card>
</template>

<script>

import store from '@/store'
import axios from '@/libs/axios'

import {
  BCard, 
  BCardHeader, 
  BCardBody, 
  BRow, 
  BCol
} from 'bootstrap-vue'

import vSelect from '@/utils/vselect.vue'

import { OrbitSpinner } from 'epic-spinners'
import { ref, watch } from '@vue/composition-api';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    OrbitSpinner
  },
  emit:['updateData'],
  props:{
    config:{
      type:Object
    }
  },
  setup(props, { emit }){

    const pending = ref(0)

    const typeOptions = ref([])
    const categoryOptions = ref([])
    const contractOptions = ref([])
    const ownerOptions = ref([])

    const typeValue = ref([])
    const categoryValue = ref([])
    const contractValue = ref([])
    const ownerValue = ref([])


    const hidden = Object.keys(props.config.staticFilters ? props.config.staticFilters : {})

    const prefix = props.config.prefix != null ? props.prefix + '_' : ''

    const getFilterOptions = () => {
      pending.value++;
      axios.get('filters/getFilterBy', {
        params: {
            type:'device', 
            ...(props.config.staticFilters ? props.config.staticFilters : {})
          }
        }
      )
      .then(res => {
        typeOptions.value = res.data.data.types
        categoryOptions.value = res.data.data.categories
        contractOptions.value = res.data.data.contracts
        ownerOptions.value = res.data.data.owners
        pending.value--;
      })

    }

    const getOptions = () => {
      pending.value++;
      axios.get('userGetLinked', {params: {
        type:'device',
        user: store.state.auth.userData.id,
        ...( typeValue.value.length > 0 && {types: typeValue.value.map((option)=> option.id)}),
        ...( categoryValue.value.length > 0 && {categories: categoryValue.value.map((option)=> option.id)}),
        ...( contractValue.value.length > 0 && {contracts: contractValue.value.map((option)=> option.id)}),
        ...( ownerValue.value.length > 0 && {owners: ownerValue.value.map((option)=> option.id)}),
        ...(props.config.staticFilters ? props.config.staticFilters : {})
      }})
      .then(res => {
        emit('updateData', res.data.data)
        pending.value--;
      })

    }

    watch(typeValue, (newValue)=> {
      emit('updateRequest', {key: prefix + 'types', value:newValue.map((option)=> option.id)})
      getOptions()
    })

    watch(categoryValue, (newValue) => {
      emit('updateRequest', {key: prefix + 'categories', value:newValue.map((option)=> option.id)})
      getOptions()
    })

    watch(contractValue, (newValue) => {
      emit('updateRequest', {key: prefix + 'contracts', value:newValue.map((option)=> option.id)})
      getOptions()
    })

    watch(ownerValue, (newValue) => {
      emit('updateRequest', {key: prefix + 'owners', value:newValue.map((option)=> option.id)})
      getOptions()
    })

    

    getFilterOptions()
    getOptions()

    return { 
        pending,
        typeOptions,
        categoryOptions,
        contractOptions,
        ownerOptions,
        typeValue,
        categoryValue,
        contractValue,
        ownerValue,
        hidden
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
